import $ from 'jquery';

const $dropdown = $('.header-dropdown-nav');
const dropdownClass = 'header-dropdown-nav';
const expandedClass = 'header-dropdown-nav--expanded';
const initialMinHeight = $dropdown.css('min-height');

let maxHeight = 0;

let clicked = false;

$('.header-dropdown-nav > li.menu-item-has-children').on('click', function(e) {
  if (!$(e.target).hasClass('menu-item-has-children') && !$($(e.target).parent()).hasClass('menu-item-has-children')) {
    return;
  }
  e.preventDefault();
  clicked = true;

  resetToDefault();

  addVisibilityClasses(this);

  setEqualHeights();

  setDropdownHeight($(this));

  setTimeout(() => {
    clicked = false;
  }, 250);
});

$('.dropdown-toggle').on('mouseover', function() {
  removeVisibilityClasses();
  $(this).parents('.menu-item').css('position', 'relative');
  if ($dropdown.find('.container').length) {
    $dropdown.find('.container').contents().unwrap();
  }
});

$dropdown.on('mouseleave', function() {
  if (clicked) {
    return;
  }
  $dropdown.css('min-height', 'auto');
  removeVisibilityClasses();
});

function addVisibilityClasses(elem) {
  $(elem).addClass('selected-menu-item');

  const $currentDropdown = $(elem).parent(`.${dropdownClass}`);
  $currentDropdown.addClass(expandedClass);
  if (!$(`.${dropdownClass} > div`).hasClass('container')) {
    $currentDropdown.wrapInner('<div class="container"></div>');
  }

  setBorderHeight();

  $(elem).parents('.menu-item').css('position', 'static');

  $(elem).find(`.${dropdownClass}__level-two`).addClass(`${dropdownClass}__level-two--visible`);
  $(elem).find(`.${dropdownClass}__level-three`).addClass(`${dropdownClass}__level-three--visible`);
}

function removeVisibilityClasses() {
  $(`.${dropdownClass}__level-two`).removeClass(`${dropdownClass}__level-two--visible`);
  $(`.${dropdownClass}__level-three`).removeClass(`${dropdownClass}__level-three--visible`);
  $dropdown.removeClass(expandedClass);
}

function resetToDefault() {
  $(`.${dropdownClass} li.menu-item-has-children`).removeClass(`selected-menu-item`);
  $(`.${dropdownClass}__level-two`).removeClass(`${dropdownClass}__level-two--visible`);
  $(`.${dropdownClass}__level-three`).removeClass(`${dropdownClass}__level-three--visible`);
}

function setEqualHeights() {
  const $currentLevelTwo = $(`.${dropdownClass}__level-two--visible`);

  maxHeight = getMaxHeightOf($currentLevelTwo.find('> li'));

  $currentLevelTwo.find(`.${dropdownClass}__level-three`).css({top: `${maxHeight}px`});
}

function setDropdownHeight(elem) {
  const pt = $dropdown.css('padding-top').replace('px', '');
  const pb = $dropdown.css('padding-bottom').replace('px', '');
  const maxLvlThreeHeight = getMaxHeightOf(elem.find('.header-dropdown-nav__level-three'));
  const height = maxHeight + maxLvlThreeHeight + pxToNumber(pt) + pxToNumber(pb);
  
  if (height > pxToNumber(initialMinHeight)) {
    $dropdown.css('min-height', height + pxToNumber(pb));
    setBorderHeight();
  } else {
    $dropdown.css('min-height', initialMinHeight);
    setBorderHeight();
  }
}

function getMaxHeightOf(elem) {
  let max = 0;
  elem.each(function() {
    const currentHeight = $(this).height();
    if (currentHeight > max) { 
      max = currentHeight; 
    }
  });

  return max;
}

function pxToNumber(px) {
  return Number(px.replace('px', ''));
}

function setBorderHeight() {
  $('.dropdown-nav__border').height($dropdown.height() + 30);
}
